import type { PropsWithChildren } from 'react';
import { Dialog, DialogContent } from '@accio3d/design-system/dialog';
import logo from '@accio3d/shared-ui/assets/arcessio-logo.svg';

/** Gives both onboarding steps the same branded dialog and subtle gradient. */
export function SupplierOnboardingDialog({
  open,
  onOpenChange,
  step,
  children,
}: PropsWithChildren<{
  open: boolean;
  onOpenChange: (open: boolean) => void;
  step: 1 | 2;
}>) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[92dvh] w-[calc(100%-2rem)] max-w-4xl gap-0 overflow-y-auto rounded-2xl p-0 sm:rounded-2xl">
        <div className="relative isolate overflow-hidden px-6 py-7 sm:p-10">
          <div
            aria-hidden="true"
            className="pointer-events-none absolute -top-32 left-1/2 -z-10 h-72 w-96 -translate-x-1/2 rounded-full bg-primary/10 blur-3xl"
          />
          <div className="mb-7 flex items-center justify-between gap-4 pr-5">
            <p className="text-xs font-medium text-muted-foreground">Step {step} of 2</p>
            <img src={logo} alt="Arcessio" className="h-6 w-auto" />
          </div>
          {children}
        </div>
      </DialogContent>
    </Dialog>
  );
}
